module.exports = __webpack_public_path__ + "assets/icIntelligence.7e2b3967.svg";